import { Namespace, TFunction } from "i18next";

type Rate = {
  name: string;
  description: string;
  price: string;
  discountPrice: string;
  /** Discounted price as a number, for callers that format it themselves. */
  discountPriceValue: number;
};

const calculateDiscountPrice = (tribeDiscount: number, price: number) => {
  return price - (price * tribeDiscount) / 100;
};

export const getFriendsWithBenefitsRates = ({
  t,
  tribeDiscount,
}: {
  t: TFunction<Namespace, undefined, Namespace>;
  tribeDiscount: number;
}): Rate[] => [
  {
    name: t("friendsWithBenefits.welcome.flatMobileSwiss"),
    description: t("friendsWithBenefits.welcome.textFlatMobileSwiss"),
    price: "CHF 13.00",
    discountPrice: `CHF ${calculateDiscountPrice(tribeDiscount, 13).toFixed(2)}`,
    discountPriceValue: calculateDiscountPrice(tribeDiscount, 13),
  },
  {
    name: t("friendsWithBenefits.welcome.flatMobile"),
    description: t("friendsWithBenefits.welcome.textFlatMobile"),
    price: "CHF 18.00",
    discountPrice: `CHF ${calculateDiscountPrice(tribeDiscount, 18).toFixed(2)}`,
    discountPriceValue: calculateDiscountPrice(tribeDiscount, 18),
  },
  {
    name: t("friendsWithBenefits.welcome.flatMobilePlus"),
    description: t("friendsWithBenefits.welcome.textFlatMobilePlus"),
    price: "CHF 25.00",
    discountPrice: `CHF ${calculateDiscountPrice(tribeDiscount, 25).toFixed(2)}`,
    discountPriceValue: calculateDiscountPrice(tribeDiscount, 25),
  },
];
